import React from "react";
import { View, StyleSheet } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";

/**
 * Legend for the {@link TimelineBar} graph. All four segment types are shown
 * persistently (worked, meal, break, non-worked) regardless of whether the
 * current timecard uses them, so the key stays stable as segments change.
 */
export function TimelineLegend() {
  const { colors } = useTheme();

  // Type colors: worked=green, meal=amber, break=gray, non-worked=primary
  const items = [
    { label: "Worked", color: colors.complete?.border || "#10b981" },
    { label: "Meal", color: colors.pending?.border || "#f59e0b" },
    { label: "Break", color: colors.neutral?.border || "#6b7280" },
    { label: "Non-worked", color: colors.primary || "#3b82f6" },
  ];

  return (
    <View style={styles.legend}>
      {items.map((item) => (
        <View key={item.label} style={styles.legendItem}>
          <View style={[styles.legendDot, { backgroundColor: item.color }]} />
          <ThemedText style={[styles.legendText, { color: colors.textSecondary }]}>{item.label}</ThemedText>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  legend: {
    flexDirection: "row",
    gap: 16,
    justifyContent: "center",
    marginTop: 4,
  },
  legendItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  legendDot: {
    width: 10,
    height: 10,
    borderRadius: 3,
  },
  legendText: {
    fontSize: 11,
  },
});
